// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__9kpta","spinning":"Spinner_spinning__VyMLo"};